import { setLocale } from "yup";

type Translate = (key: string, params?: Record<string, unknown>) => string;

/**
 * Messages resolve when a rule fails, so they follow the active locale once its catalog has loaded.
 *
 * Every message yup would otherwise build from `${path}` (such as "body must be at most 4096 characters") is set
 * here, so a raw schema path never reaches the screen. A field with a `.label(...)` is named in its required
 * message.
 */
export function setYupLocales(t: Translate): void {
  function requiredMessage({ label }: { label?: string }): string {
    return label ? t("base.forms.required_named", { field: label }) : t("base.forms.required");
  }

  setLocale({
    mixed: {
      default: () => t("base.forms.invalid"),
      required: requiredMessage,
      notNull: requiredMessage,
      oneOf: requiredMessage,
      notOneOf: requiredMessage,
      notType: requiredMessage,
    },
    string: {
      email: () => t("base.forms.email"),
      min: ({ min }) => t("base.forms.min_length", { min }),
      max: ({ max }) => t("base.forms.max_length", { max }),
    },
    array: {
      min: () => t("base.forms.required"),
      max: ({ max }) => t("base.forms.max", { max }),
    },
    number: {
      min: ({ min }) => t("base.forms.min", { min }),
      max: ({ max }) => t("base.forms.max", { max }),
      positive: () => t("base.forms.positive_amount"),
    },
  });
}
